<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! No Monitoramento do Desempenho Comportamental você encontra três abas:
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          1. <b>Resultado dos servidores</b><br>
          2. <b>Relatórios Gerenciais</b><br>
          3. <b>Relatórios Gerenciais por unidades</b>
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Resultado dos servidores
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Resultado dos servidores”</b> você encontra dois tipos de
          filtros: <br>
          1. <b>Unidade</b><br>
          2. <b>Servidores avaliados</b>
        </p>

        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          No filtro <b>“Unidade”</b> você pode selecionar qualquer unidade
          hierarquicamente vinculada a sua. E no filtro <b>“Servidores avaliados”</b>,
          você encontra os membros da equipe da unidade selecionada. Ao selecionar
          um servidor, é possível analisar, por meio de gráficos e tabelas, os dados
          referentes ao desempenho comportamental do servidor selecionado, no ano
          em análise.
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Resultado dos servidores<br>
        Gráficos e tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na primeira tabela são apresentadas as duas competências comportamentais
          identificadas como talentos do servidor selecionado e as duas mais indicadas
          para desenvolvimento.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O velocímetro expressa o resultado obtido pelo servidor após a etapa diagnóstico
          comportamental, utilizando a ponderação:
        </p>
        <p class="mx-2 pa-2 text-center font-weight-medium text-lg-h6">
          40% (autoavaliação) + 60% (nota gestor)<br>
          Quando há nota da equipe, a ponderação é feita da seguinte forma:<br>
          20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe)
        </p>
      </div>
    </div>

    <div>
      <h2>
        1. Resultado dos servidores<br>
        Gráficos e tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na segunda tabela é possível observar as doze competências comportamentais e
          expandir cada competência para observar os comportamentos que a compõem.
          Prezando pela transparência dos dados, as colunas apresentam as notas alcançadas
          na autoavaliação, na avaliação do gestor e na avaliação da equipe (quando houver).
          A tabela apresenta ainda nota máxima a ser alcançada em cada competência e a
          coluna resultado, que utiliza a ponderação:
        </p>
        <p class="mx-2 pa-2 text-center font-weight-medium text-lg-h6">
          40% (autoavaliação) + 60% (nota gestor)<br>
          Quando há nota da equipe, a ponderação é feita da seguinte forma:<br>
          20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe)
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação
          de forma crescente ou decrescente por: responsabilidade, notas, competências técnicas,
          além de permitir a pesquisa por qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>
        2. Relatórios gerenciais<br>
        Gráficos e tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Relatórios gerenciais”</b>, você encontra o filtro <b>“Unidade”</b>, onde
          pode selecionar mais de uma unidade. Ao escolher várias unidades, é possível analisar,
          por meio de gráficos e tabelas, dados conjuntos das unidades selecionadas.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na primeira tabela são apresentadas as duas competências comportamentais identificadas
          como talentos das unidades selecionadas e as duas mais indicadas para o desenvolvimento.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O velocímetro expressa o resultado médio obtido pelos servidores das unidades selecionadas
          utilizando a ponderação:
        </p>
        <p class="mx-2 pa-2 text-center font-weight-medium text-lg-h6">
          40% (autoavaliação) + 60% (nota gestor)<br>
          Quando há nota da equipe, a ponderação é feita da seguinte forma:<br>
          20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe)
        </p>
      </div>
    </div>

    <div>
      <h2>
        2. Relatórios gerenciais<br>
        Gráficos e tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na segunda tabela é possível observar as doze competências comportamentais e expandir cada
          competência para observar os resultados médios das unidades selecionadas em cada uma delas.
          Prezando pela transparência dos dados, as colunas apresentam os resultados máximos, a média
          da unidade e o desvio padrão de cada competência.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação de forma
          crescente ou decrescente por: competência, resultado máximo, média e desvio padrão, além de
          permitir a pesquisa por qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>
        3. Relatórios gerenciais por unidade
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na aba <b>“Relatórios gerenciais por unidade”</b>, você encontra o filtro <b>“Unidade”</b>.
          Ao selecionar uma unidade, é possível analisar, por meio de gráficos e tabelas, dados conjuntos
          da unidade selecionada.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na primeira tabela são apresentadas as duas competências comportamentais identificadas como talentos
          da unidade selecionada e as duas mais indicadas para o desenvolvimento.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          O velocímetro expressa o resultado conjunto obtido pelos servidores da unidade selecionada após
          a etapa diagnóstico comportamental utilizando a ponderação:
        </p>
        <p class="mx-2 pa-2 text-center font-weight-medium text-lg-h6">
          40% (autoavaliação) + 60% (nota gestor)<br>
          Quando há nota da equipe, a ponderação é feita da seguinte forma:<br>
          20% (autoavaliação) + 40% (nota gestor) + 40% (nota da equipe)
        </p>
      </div>
    </div>

    <div>
      <h2>
        3. Relatórios gerenciais por unidade<br>
        Tabelas
      </h2>
      <div>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Na segunda tabela é possível observar as doze competências comportamentais e expandir cada
          competência para observar os resultados dos servidores em cada uma delas. Prezando pela
          transparência dos dados, as colunas apresentam os resultados máximos, a média da unidade
          e o desvio padrão de cada competência.
        </p>
        <p class="mx-2 pa-2 text-start font-weight-medium text-lg-h6">
          Para melhor interagir com a tabela, pode-se ainda utilizar os recursos de ordenação de forma
          crescente ou decrescente por: competência, resultado máximo, média e desvio padrão, além de permitir
          a pesquisa por qualquer termo exibido na tabela.
        </p>
      </div>
    </div>

    <div>
      <h2>Importante!</h2>
      <div class="mx-2 pa-2 justify-center">
        <ul>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba <b>“1. Servidores avaliados”</b> para analisar o desempenho
              individual de cada servidor.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba <b>“2. Relatórios gerenciais”</b> para analisar o desempenho
              conjunto das unidades.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Recomenda-se visitar a aba <b>“3. Relatórios gerenciais por unidade”</b> para analisar o
              desempenho conjunto dos servidores da unidade.
            </p>
          </li>
          <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              O Gestor pode trabalhar os dados expostos, por meio dos gráficos e tabelas, com sua equipe
              no intuito de verificar os talentos da unidade e direcionar as ações de desenvolvimento de
              competências comportamentais.
            </p>
          </li>
          <!-- <li>
            <p class="text-start font-weight-medium info--text text-lg-h6">
              Você pode imprimir todos os resultados na opção de baixar PDF.
            </p>
          </li> -->
        </ul>
      </div>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../../BaseTutorial';

export default {
  name: 'TutorialMonitoramentoDesempenhoGeralComportamental',

  components: { BaseTutorial },

  data() {
    return {
      steps: [
        'Introdução',
        'Resultado dos servidores',
        'Resultado dos servidores',
        'Resultado dos servidores',
        'Relatórios gerenciais',
        'Relatórios gerenciais',
        'Relatórios gerenciais por unidade',
        'Relatórios gerenciais por unidade',
        'Importante',
      ],
    };
  },
};
</script>
